import axios from 'axios'
import { ElMessage } from 'element-plus'
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_Head, // url = base url + request url
  // baseURL: 'https://apps.zqwl123.com/', // url = base url + request url
  baseURL: 'https://www.csjmj.com/service/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    console.log(config)
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code !== 1000) {
      ElMessage({
        message: res.msg,
        type: 'error',
      })
      return Promise.reject(new Error(`request ${res.msg || 'Error'}`))
    } else {
      return res
    }

  },
  error => { // 响应错误处理
    ElMessage({
      message: '网络异常，请重试',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
